import type { CSSProperties, ReactNode } from 'react';
import estilos from './Card.module.css';

interface CardProps {
  children: ReactNode;
  /** Radio y espaciado mayores, para tarjetas protagonistas. */
  destacada?: boolean;
  /** Color de la franja izquierda (severidad, estado de comando…). */
  colorAcento?: string;
  onClick?: () => void;
  className?: string;
  style?: CSSProperties;
  /** Etiqueta accesible cuando la tarjeta es pulsable. */
  etiqueta?: string;
}

export function Card({
  children,
  destacada = false,
  colorAcento,
  onClick,
  className,
  style,
  etiqueta,
}: CardProps) {
  const clases = [
    estilos.tarjeta,
    destacada ? estilos.destacada : '',
    colorAcento ? estilos.conAcento : '',
    onClick ? estilos.interactiva : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const estiloFinal: CSSProperties = colorAcento
    ? { ...style, borderLeftColor: colorAcento }
    : (style ?? {});

  // Una tarjeta pulsable debe ser un botón real: así funciona con teclado y
  // los lectores de pantalla la anuncian correctamente.
  if (onClick) {
    return (
      <button
        type="button"
        className={clases}
        style={estiloFinal}
        onClick={onClick}
        aria-label={etiqueta}
      >
        {children}
      </button>
    );
  }

  return (
    <div className={clases} style={estiloFinal}>
      {children}
    </div>
  );
}

export function CardHeader({ children }: { children: ReactNode }) {
  return <div className={estilos.encabezado}>{children}</div>;
}

export function CardTitle({ children, subtitulo }: { children: ReactNode; subtitulo?: string }) {
  return (
    <div>
      <h3 className={estilos.titulo}>{children}</h3>
      {subtitulo && <div className={estilos.subtitulo}>{subtitulo}</div>}
    </div>
  );
}
